import { makeStyles, tokens, Text, Divider } from "@fluentui/react-components";
import React from "react";
import { useTranslation } from "react-i18next";
import parkingSign from "../img/parking_sign.png";
import stopSign from "../img/stop_sign.png";
import warningTriangleSign from "../img/warning_triangle_sign.png";
import { ChevronLeftFilled, ChevronRightFilled } from "@fluentui/react-icons";
const useStyles = makeStyles({
  textWrapper: {
    display: "flex",
    flexDirection: "column",
    marginTop: tokens.spacingVerticalXXL,
    "> p": {
      fontSize: tokens.fontSizeBase400,
      margin: `${tokens.spacingVerticalS} 0`,
    },
    "> ul": {
      fontSize: tokens.fontSizeBase400,
    },
    "@media (max-width: 1700px)": {
      marginTop: tokens.spacingVerticalM,
      "> p": {
        fontSize: tokens.fontSizeBase300,
      },
      "> ul": {
        fontSize: tokens.fontSizeBase300,
      },
    },
  },
  headerTitle: {
    fontSize: tokens.fontSizeHero900,
    fontWeight: tokens.fontWeightBold,
    lineHeight: tokens.lineHeightHero900,
    margin: `${tokens.spacingHorizontalXL} 0`,
  },
  subHeaderTitle: {
    fontSize: tokens.fontSizeBase600,
    fontWeight: tokens.fontWeightBold,
    margin: `${tokens.spacingHorizontalL} 0`,
  },
  divider: {
    "::before": {
      borderTopWidth: tokens.strokeWidthThick,
    },
    "::after": {
      borderTopWidth: tokens.strokeWidthThick,
    },
  },
});
export const SizePopOver = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  return (
    <>
      <p>
        {t("popover.size.pt1")} <b>{t("popover.size.pt2")}</b>{" "}
        {t("popover.size.pt3")}
      </p>
      <ul>
        <li>
          <b> {t("popover.size.pt4")}</b> {t("popover.size.pt5")}
        </li>
        <li>
          <b> {t("popover.size.pt6")} </b> {t("popover.size.pt7")}
        </li>
        <li>
          <b>{t("popover.size.pt8")}</b> {t("popover.size.pt9")}
        </li>
      </ul>
      <p>
        <i>{t("popover.size.pt10")}</i>
      </p>
      <p>{t("popover.size.pt11")}</p>
      <div
        style={{
          display: "flex",
          gap: 32,
          alignItems: "center",
          justifyContent: "space-around",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <img src={parkingSign} alt="P-skylt" />
          <div
            style={{ display: "flex", alignItems: "center", marginTop: "8px" }}
          >
            <ChevronLeftFilled />
            <Divider
              appearance="brand"
              style={{ color: "black" }}
              className={styles.divider}
            >{`400mm`}</Divider>
            <ChevronRightFilled />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <img src={warningTriangleSign} alt="Varningsskylt" />
          <div
            style={{ display: "flex", alignItems: "center", marginTop: "8px" }}
          >
            <ChevronLeftFilled />
            <Divider
              appearance="brand"
              style={{ color: "black" }}
              className={styles.divider}
            >{`600mm`}</Divider>
            <ChevronRightFilled />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <img src={stopSign} alt="Stoppskylt" />
          <div
            style={{ display: "flex", alignItems: "center", marginTop: "8px" }}
          >
            <ChevronLeftFilled />
            <Divider
              appearance="brand"
              style={{ color: "black" }}
              className={styles.divider}
            >
              {`600mm`}
            </Divider>
            <ChevronRightFilled />
          </div>
        </div>
      </div>
    </>
  );
};

export const TextPopOver = () => {
  const { t } = useTranslation();
  return (
    <>
      <p>
        {t("popover.text.pt1")} <b>{t("popover.text.pt2")}</b>
        {t("popover.text.pt3")}
      </p>
      <p>{t("popover.text.pt4")}</p>
    </>
  );
};

export const MountingPointPopOver = () => {
  const { t } = useTranslation();
  return (
    <>
      <p>{t("popover.mounting.pt0")}</p>
      <ul>
        <li>
          <b>{t("popover.mounting.pt1")}</b> {t("popover.mounting.pt2")}{" "}
          <b>{t("popover.mounting.pt3")}</b> {t("popover.mounting.pt4")}
        </li>
        <li>
          <b>{t("popover.mounting.pt5")}</b> {t("popover.mounting.pt6")}{" "}
          <b>{t("popover.mounting.pt7")}</b> {t("popover.mounting.pt8")}
        </li>
      </ul>
      <p>
        <i>{t("popover.mounting.pt9")}</i>
      </p>
    </>
  );
};

export const MountPopOver = () => {
  const { t } = useTranslation();
  return (
    <>
      <p>{t("popover.mount.pt1")}</p>
      <ul>
        <li>
          <b>{t("popover.mount.pt2")}</b> {t("popover.mount.pt3")}
        </li>
        <li>
          <b>{t("popover.mount.pt4")}</b>
          <ul>
            <li>
              <b>{t("popover.mount.pt5")}</b> {t("popover.mount.pt6")}
            </li>
            <li>
              <b>{t("popover.mount.pt7")}</b> {t("popover.mount.pt8")}
            </li>
          </ul>
        </li>
        <li>
          <b>{t("popover.mount.pt9")}</b> {t("popover.mount.pt10")}
        </li>
      </ul>
      <p>
        <i>{t("popover.mount.pt11")}</i>
      </p>
    </>
  );
};

export const LandingPageHeaderSection = () => {
  const styles = useStyles();
  const { t } = useTranslation();
  return (
    <div className={styles.textWrapper}>
      <Text className={styles.headerTitle} as="h1">
        {t("label.designYourSign")}
      </Text>
      <Text as="p">{t("textTemplate.landingPageHeaderSection.pt1")}</Text>
      <Text as="p">{t("textTemplate.landingPageHeaderSection.pt2")}</Text>
    </div>
  );
};
export const LandingPageBottomSection = () => {
  const styles = useStyles();
  const { t } = useTranslation();
  return (
    <div className={styles.textWrapper}>
      <Text className={styles.subHeaderTitle} as="h1">
        {t("label.howTo")}
      </Text>
      <Text as="p">{t("textTemplate.landingPageBottomSection.pt1")}</Text>
      <ul>
        <li>
          <b> {t("textTemplate.landingPageBottomSection.pt2")}</b>
          {t("textTemplate.landingPageBottomSection.pt3")}
        </li>
        <li>
          <b> {t("textTemplate.landingPageBottomSection.pt4")}</b>
          {t("textTemplate.landingPageBottomSection.pt5")}
        </li>
      </ul>
      <Text as="p">{t("textTemplate.landingPageBottomSection.pt6")}</Text>
      <Text as="p">{t("textTemplate.landingPageBottomSection.pt7")}</Text>
      <Text as="p">{t("textTemplate.landingPageBottomSection.pt8")}</Text>
    </div>
  );
};

export const OrderConfirmationMsg = () => {
  const styles = useStyles();
  const { t } = useTranslation();
  return (
    <div className={styles.textWrapper}>
      <Text as="p">{t("textTemplate.orderConfirmation.pt1")}</Text>
      <Text as="p">
        {t("textTemplate.orderConfirmation.pt2")}{" "}
        <b>{t("textTemplate.orderConfirmation.pt3")}</b>
      </Text>
    </div>
  );
};
